import _TextField from "@material-ui/core/esm/TextField";
import _Select from "@material-ui/core/esm/Select";
import _MenuItem from "@material-ui/core/esm/MenuItem";
import React, { useMemo } from 'react';
import classnames from 'classnames';
import { Button } from 'swag-client-common/components/ui/button';
import { COUNTRIES } from 'swag-common/utils/shipping';
import { HiddenLabel } from 'swag-client-common/components/hidden-label';
import { capitalize } from 'swag-common/utils/strings';
import NumberInput from '../number-input';
import { EmailForm } from '../email-form';
import { PriceSummary } from '../price-summary';
import classes from '../../instant-quote-popup.scss';
const Row = ({
  rowNumber,
  error,
  children,
  className
}) => /*#__PURE__*/React.createElement("div", {
  className: classes.row
}, /*#__PURE__*/React.createElement("div", {
  className: classnames(classes.inputLine, className)
}, rowNumber && /*#__PURE__*/React.createElement("div", {
  className: classes.number
}, rowNumber, "."), children), error && /*#__PURE__*/React.createElement("div", {
  className: classes.error
}, error));
export const InstantQuoteFormComponent = ({
  quantity,
  zip,
  shippingError,
  locations,
  quantityError,
  maxLocations,
  onQuantityChange,
  onZipChange,
  isFullDesignProduct,
  onLocationsChange,
  locationsError,
  colorsNumbers,
  onColorsChange,
  colorsNumbersErrors,
  sizeIndex,
  sizes,
  onSizeIndexChange,
  onSubmit,
  isSubmitDisabled,
  totalPrice,
  isSizeDependentPrice,
  shippingCountry,
  onShippingCountryChange,
  isCustomizedBlank,
  isLimitedEdition,
  showDecorationMethodSelect,
  productSettings,
  selectedEmbellishmentMethod,
  updateEmbellishmentMethod
}) => {
  const embellishmentRequiredError = showDecorationMethodSelect && !selectedEmbellishmentMethod;
  const embellishmentSelectOptions = useMemo(() => productSettings.map(({
    embellishmentMethod
  }) => ({
    _id: embellishmentMethod._id,
    label: capitalize(embellishmentMethod.name)
  })), [productSettings]);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.wrapper
  }, /*#__PURE__*/React.createElement("form", {
    className: classes.form
  }, showDecorationMethodSelect && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, {
    className: classes.decorationMethodRow
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.beforeInput
  }, "Decoration method"), /*#__PURE__*/React.createElement("div", {
    className: classes.inputWrapper
  }, /*#__PURE__*/React.createElement(_Select, {
    displayEmpty: true,
    required: true,
    value: selectedEmbellishmentMethod || '',
    onChange: event => {
      updateEmbellishmentMethod(event.target.value);
    },
    fullWidth: true,
    classes: {
      select: classes.select
    },
    className: classnames(classes.sizePicker, {
      [classes.orangePicker]: isLimitedEdition
    }),
    inputProps: {
      dataInput: 'decorationMethod',
      id: 'decorationMethod'
    }
  }, /*#__PURE__*/React.createElement(_MenuItem, {
    value: "",
    disabled: true,
    className: classes.menuItem
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.disabled
  }, " Select decoration method ")), embellishmentSelectOptions.map(embellishment => /*#__PURE__*/React.createElement(_MenuItem, {
    key: embellishment._id,
    value: embellishment._id,
    className: classes.menuItem
  }, embellishment.label))))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement("hr", {
    className: classes.hr
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement("div", {
    className: classes.beforeInput
  }, "Quantity"), /*#__PURE__*/React.createElement("div", {
    className: classes.inputWrapper
  }, /*#__PURE__*/React.createElement(HiddenLabel, {
    htmlFor: "instantQuoteQuantity",
    label: "Quantity"
  }), /*#__PURE__*/React.createElement(NumberInput, {
    id: "instantQuoteQuantity",
    value: quantity || 0,
    onChange: onQuantityChange,
    required: true,
    dataBlock: "Quantity",
    min: "0"
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.error
  }, quantityError)), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement("hr", {
    className: classes.hr
  })), isSizeDependentPrice && /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement("div", {
    className: classes.beforeInput
  }, "Size"), /*#__PURE__*/React.createElement("div", {
    className: classes.inputWrapper
  }, /*#__PURE__*/React.createElement(_Select, {
    value: sizeIndex,
    onChange: event => {
      onSizeIndexChange(event.target.value);
      return event;
    },
    fullWidth: true,
    classes: {
      select: classes.select
    },
    className: classes.sizePicker,
    inputProps: {
      dataInput: 'sizePickerInput',
      id: 'sizePickerInput'
    }
  }, ((sizes === null || sizes === void 0 ? void 0 : sizes.options) || []).map((v, i) => /*#__PURE__*/React.createElement(_MenuItem, {
    key: i,
    value: i,
    className: classes.menuItem
  }, v))))), isSizeDependentPrice && /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement("hr", {
    className: classes.hr
  })), !isFullDesignProduct && !isCustomizedBlank && /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.beforeInput, {
      [classes.disabled]: embellishmentRequiredError
    })
  }, "Print locations"), /*#__PURE__*/React.createElement("div", {
    className: classes.inputWrapper
  }, /*#__PURE__*/React.createElement(HiddenLabel, {
    htmlFor: "instantQuotePrintLocations",
    label: "Print locations"
  }), /*#__PURE__*/React.createElement(NumberInput, {
    id: "instantQuotePrintLocations",
    value: locations || 0,
    onChange: onLocationsChange,
    required: true,
    dataBlock: "PrintLocations",
    min: "1",
    max: maxLocations,
    disabled: embellishmentRequiredError,
    tooltipMessage: "Please select decorating method before selecting print locations."
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.error
  }, locationsError)), !isFullDesignProduct && !isCustomizedBlank && /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement("hr", {
    className: classes.hr
  })), !isFullDesignProduct && !isCustomizedBlank && (colorsNumbers === null || colorsNumbers === void 0 ? void 0 : colorsNumbers.map((colorsNumber, locationIndex) => {
    if (locationIndex !== 0 && locationsError) {
      return null;
    }
    const inputId = `instantQuoteColorsNumber${locationIndex}`;
    return /*#__PURE__*/React.createElement(Row, {
      key: locationIndex
    }, /*#__PURE__*/React.createElement("div", {
      className: classnames(classes.beforeInput, {
        [classes.disabled]: embellishmentRequiredError
      })
    }, "Colors:\xA0", /*#__PURE__*/React.createElement("span", null, `Print location ${locationIndex + 1}`)), /*#__PURE__*/React.createElement("div", {
      className: classes.inputWrapper
    }, /*#__PURE__*/React.createElement(HiddenLabel, {
      htmlFor: inputId,
      label: `Colors for print location ${locationIndex + 1}`
    }), /*#__PURE__*/React.createElement(NumberInput, {
      id: inputId,
      value: colorsNumber,
      onChange: e => onColorsChange(e.target.value, locationIndex),
      required: true,
      dataBlock: "LocationColor",
      min: "1",
      disabled: embellishmentRequiredError,
      tooltipMessage: "Please select decorating method before selecting print locations."
    })), /*#__PURE__*/React.createElement("div", {
      className: classes.error
    }, colorsNumbersErrors === null || colorsNumbersErrors === void 0 ? void 0 : colorsNumbersErrors[locationIndex]));
  })), !isFullDesignProduct && !isCustomizedBlank && /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement("hr", {
    className: classes.hr
  })), /*#__PURE__*/React.createElement(Row, {
    className: classes.zipNumber
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.beforeInput
  }, "Shipping ZIP code"), /*#__PURE__*/React.createElement("div", {
    className: classes.inputWrapper
  }, /*#__PURE__*/React.createElement(_TextField, {
    id: "zip",
    "data-input": "zip",
    type: "text",
    value: zip,
    onChange: onZipChange,
    className: classnames(classes.textField, {
      [classes.orangeBorder]: isLimitedEdition
    }),
    inputProps: {
      className: classes.textInput
    },
    required: true,
    placeholder: "Zip code"
  }))), /*#__PURE__*/React.createElement(Row, {
    className: classes.countryRow
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.beforeInput
  }, "Country"), /*#__PURE__*/React.createElement("div", {
    className: classes.inputWrapper
  }, /*#__PURE__*/React.createElement(_Select, {
    value: shippingCountry,
    onChange: event => {
      return onShippingCountryChange(event.target.value);
    },
    fullWidth: true,
    classes: {
      select: classes.select
    },
    className: classnames(classes.sizePicker, {
      [classes.orangePicker]: isLimitedEdition
    }),
    inputProps: {
      dataInput: 'sizePickerInput',
      id: 'sizePickerInput'
    }
  }, COUNTRIES.map(({
    code,
    label
  }) => /*#__PURE__*/React.createElement(_MenuItem, {
    key: code,
    value: code,
    className: classes.menuItem
  }, label))))), /*#__PURE__*/React.createElement("div", {
    className: classes.error
  }, shippingError), /*#__PURE__*/React.createElement("div", {
    className: classes.formFooter
  }, /*#__PURE__*/React.createElement(Button, {
    dataButton: "GetQuote",
    className: classnames(classes.formButton, {
      [classes.orangeBackground]: isLimitedEdition
    }),
    type: "primary",
    disabled: isSubmitDisabled,
    onClick: e => {
      e.preventDefault();
      onSubmit();
    }
  }, totalPrice ? 'Update Quote' : 'Get Quote'), totalPrice && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PriceSummary, null), /*#__PURE__*/React.createElement(EmailForm, null)))));
};